module.exports = __webpack_public_path__ + "img/title_market.f6376212.png";